var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLiechtenstein(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_759_6849)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24 12C24 18.6274 18.6274 24 12 24C5.37262 24 0 18.6274 0 12C0.521719 12 12 10.4348 12 10.4348L24 12Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 12C0 5.37262 5.37262 0 12 0C18.6274 0 24 5.37262 24 12",
    fill: "#0052B4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.86956 8.34782C8.86956 7.4834 8.16878 6.78262 7.30436 6.78262C6.90334 6.78262 6.53786 6.93355 6.26088 7.18148V6.26085H6.78259V5.21737H6.26088V4.69565H5.21739V5.21737H4.69567V6.26085H5.21739V7.18148C4.94041 6.93355 4.57492 6.78262 4.17391 6.78262C3.30948 6.78262 2.6087 7.4834 2.6087 8.34782C2.6087 8.81127 2.81031 9.22752 3.13042 9.51416V10.4348H8.3478V9.51416C8.668 9.22752 8.86956 8.81127 8.86956 8.34782Z",
    fill: "#FFDA44"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_759_6849"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLiechtenstein);
export default __webpack_public_path__ + "static/media/liechtenstein.2dc9e10ca83f00b46f314b48441cdc6b.svg";
export { ForwardRef as ReactComponent };